import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingCompressPngConfig } from '@/data/landingConfig/landingCompressPngConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_CompressPng } from './schemaObject';

interface Props {}
const CompressPng: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_CompressPng} />
			<LandingTemplate
				data={landingCompressPngConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageCompressor()}
			/>
		</>
	);
};

export default CompressPng;
